import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Form } from 'antd';
import { txt } from 'libs/i18n';
import SelectWithActions from 'components/SelectWithActions';
import Role from '../../../Role';
const NameVariantWithRole = ({ dbSpeaker, nameVariant, role, init, autoFocus = false, isNameVariantRequired = false, openAddRoleModal, documentRole, onAddRoleModalClose, }) => {
    var _a;
    const form = Form.useFormInstance();
    const formNameVariant = Form.useWatch('nameVariant', form);
    const roleOptions = role.getRoles((_a = formNameVariant === null || formNameVariant === void 0 ? void 0 : formNameVariant.label) !== null && _a !== void 0 ? _a : '', documentRole);
    useEffect(() => {
        init(dbSpeaker);
    }, [dbSpeaker]);
    useEffect(() => {
        if (dbSpeaker !== null) {
            void form.validateFields(['nameVariant']);
        }
    }, [nameVariant.options.length]);
    useEffect(() => {
        var _a;
        if (roleOptions.length > 0) {
            form.setFieldValue('role', (_a = roleOptions.find((r) => r.isDefault)) !== null && _a !== void 0 ? _a : roleOptions[0]);
        }
    }, [formNameVariant === null || formNameVariant === void 0 ? void 0 : formNameVariant.label]);
    const addNameVariant = (item) => {
        nameVariant.add(item);
        form.setFieldValue('role', null);
        form.setFieldValue('nameVariant', item);
    };
    const editNameVariant = (newItem, originalItem) => {
        nameVariant.edit(newItem, originalItem);
        form.setFieldValue('role', null);
        form.setFieldValue('nameVariant', newItem);
    };
    const deleteNameVariant = (value) => {
        nameVariant.delete(value);
        const current = form.getFieldValue('nameVariant');
        if ((current === null || current === void 0 ? void 0 : current.label) === value) {
            form.setFieldValue('role', null);
            form.setFieldValue('nameVariant', null);
        }
    };
    const addRole = (item) => {
        role.add(formNameVariant, item);
        form.setFieldValue('role', item);
    };
    const editRole = (newItem, originalItem) => {
        role.edit(formNameVariant, newItem, originalItem);
        form.setFieldValue('role', newItem);
    };
    const deleteRole = (value) => {
        role.delete(formNameVariant, value);
        const current = form.getFieldValue('role');
        if ((current === null || current === void 0 ? void 0 : current.label) === value) {
            form.setFieldValue('role', null);
        }
    };
    return (_jsxs(_Fragment, { children: [dbSpeaker !== null && (_jsx(SelectWithActions, { fieldName: "nameVariant", label: txt('nameVariant'), addLabel: txt('addNameVariant'), editLabel: txt('editNameVariant'), options: nameVariant.options, onAdd: addNameVariant, onEdit: editNameVariant, onDelete: deleteNameVariant, fields: [
                    { key: 'firstName', label: txt('firstName') },
                    {
                        key: 'lastName',
                        label: txt('lastName'),
                        rules: [{ required: true, message: txt('lastNameRequired') }],
                    },
                ], autoFocus: autoFocus, allowStar: true, storeFullItem: true, rules: [{
                        validator: async (_, value) => {
                            if (nameVariant.options.length === 0) {
                                return Promise.reject(txt('nameVariantRequired'));
                            }
                            if (isNameVariantRequired && value == null) {
                                return Promise.reject(txt('nameVariantSelectRequired'));
                            }
                            return Promise.resolve();
                        },
                    }] })), _jsx(Role, { multiple: dbSpeaker !== null, options: roleOptions, onAdd: addRole, onEdit: editRole, onDelete: deleteRole, autoFocus: autoFocus && dbSpeaker === null, openAddModal: openAddRoleModal, onClose: onAddRoleModalClose })] }));
};
export default NameVariantWithRole;
